import createUpdateFilesEvents from '/src/lib/custom/js/createupdatefilejson.js';

import mainPageEvents from '/src/lib/custom/js/mainpages.js';

const pointyDevices = window.matchMedia('(pointer: fine)').matches;

const leftsidebarpopulate = (() => {
  const listeners = [];
  const init = async () => {
    unloadAll();



    // Collapsible toggle event
    const toggleButton = document.querySelector('.collapsible-toggle');
    const content = document.querySelector('.collapsible-content');
    const iconCollapse = document.querySelector('.icon-collapse');
    const iconExpand = document.querySelector('.icon-expand');

    const toggleButtonTemplates = document.querySelector('.collapsible-toggle-templates');
    const contentTemplates = document.querySelector('.collapsible-content-templates');
    const iconCollapseTemplates = document.querySelector('.icon-collapse-templates');
    const iconExpandTemplates = document.querySelector('.icon-expand-templates');
    //console.log("pointyDevices", pointyDevices);

    if (toggleButton && content && iconCollapse && iconExpand) {
      const isOpen = getSessionToggleState('toggleButtonOpen');
      content.classList.toggle('open', isOpen);
      iconCollapse.classList.toggle('hidden', !isOpen);
      iconExpand.classList.toggle('hidden', isOpen);

      addListener(toggleButton, 'click', () => {
        const nowOpen = !content.classList.contains('open');
        content.classList.toggle('open');
        iconCollapse.classList.toggle('hidden');
        iconExpand.classList.toggle('hidden');
        setSessionToggleState('toggleButtonOpen', nowOpen);
      });
    }



    if (toggleButtonTemplates && contentTemplates && iconCollapseTemplates && iconExpandTemplates) {
      const isOpenTemplates = getSessionToggleState('toggleButtonTemplatesOpen');
      contentTemplates.classList.toggle('open', isOpenTemplates);
      iconCollapseTemplates.classList.toggle('hidden', !isOpenTemplates);
      iconExpandTemplates.classList.toggle('hidden', isOpenTemplates);

      addListener(toggleButtonTemplates, 'click', () => {
        const nowOpen = !contentTemplates.classList.contains('open');
        contentTemplates.classList.toggle('open');
        iconCollapseTemplates.classList.toggle('hidden');
        iconExpandTemplates.classList.toggle('hidden');
        setSessionToggleState('toggleButtonTemplatesOpen', nowOpen);
      });
    }


    const refreshed = getCookie('refreshed');
    if (refreshed) {
      $('#refresh-my-resumes').hide();
    } else {
      $('#refresh-my-resumes').show();
    }
    // Generate content dynamically
    populateLeftSidebarContent();
    populateTemplates();



    // Dropdown toggle events
    const shadowHost = document.querySelector('#resume-leftsidebar-host'); // Replace with the actual host selector
    if (shadowHost && shadowHost.shadowRoot) {
      const ellipsisButtons = shadowHost.shadowRoot.querySelectorAll('.leftsidebar-ellipsis-button');
      if (ellipsisButtons) {
        const populateDropdown = (dropdown) => {
          if (dropdown.innerHTML) return; // Avoid re-creating the dropdown content

          dropdown.innerHTML = `
             <div class="myresumes-option" data-action="open">
          <svg width="16" height="16" class="icon" viewBox="0 0 16 16" fill="currentColor">
            <path d="M1 3.5A1.5 1.5 0 0 1 2.5 2h2.764c.958 0 1.76.56 2.311 1.184C7.985 3.648 8.48 4 9 4h4.5A1.5 1.5 0 0 1 15 5.5v.64c.57.265.94.876.856 1.546l-.64 5.124A2.5 2.5 0 0 1 12.733 15H3.266a2.5 2.5 0 0 1-2.481-2.19l-.64-5.124A1.5 1.5 0 0 1 1 6.14zM2 6h12v-.5a.5.5 0 0 0-.5-.5H9c-.964 0-1.71-.629-2.174-1.154C6.374 3.334 5.82 3 5.264 3H2.5a.5.5 0 0 0-.5.5zm-.367 1a.5.5 0 0 0-.496.562l.64 5.124A1.5 1.5 0 0 0 3.266 14h9.468a1.5 1.5 0 0 0 1.489-1.314l.64-5.124A.5.5 0 0 0 14.367 7z"></path>
          </svg> Open
          </div>
          <div class="myresumes-option" data-action="share">
            <svg width="16" height="16" class="icon" viewBox="0 0 16 16" fill="currentColor">
              <path d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.5 2.5 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5m-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"></path>
            </svg> Share
          </div>
          <div class="myresumes-option" data-action="rename">
            <svg width="16" height="16" class="icon" viewBox="0 0 16 16" fill="currentColor">
              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325"></path>
            </svg> Rename
          </div>
          <div class="myresumes-option" data-action="delete">
            <svg width="16" height="16" class="icon" viewBox="0 0 16 16" fill="currentColor">
              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"></path>
              <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"></path>
            </svg> Delete
          </div>

          `;
        };

        if (pointyDevices) {
          ellipsisButtons.forEach((ellipsisButton) => {
            addListener(ellipsisButton, 'click', (event) => {
              event.stopPropagation(); // Prevent the click from propagating to other elements

              // Find the corresponding dropdown
              const dropdown = ellipsisButton.nextElementSibling;

              populateDropdown(dropdown);

              // Toggle the visibility of the dropdown
              if (dropdown) {
                dropdown.classList.toggle('hidden');
              }

              // Close other open dropdowns
              shadowHost.shadowRoot.querySelectorAll('.leftsidebar-dropdown').forEach((otherDropdown) => {
                if (otherDropdown !== dropdown && !otherDropdown.classList.contains('hidden')) {
                  otherDropdown.classList.add('hidden');
                }
              });
            });
          });
        } else {
          console.warn("No ellipsis buttons found for dropdown functionality.");
        }

        // Close dropdown when clicking outside
        addListener(document, 'click', () => {
          shadowHost.shadowRoot.querySelectorAll('.leftsidebar-dropdown').forEach((dropdown) => {
            dropdown.classList.add('hidden');
          });
        });
      }


    }


    mainPageEvents.updateLeftSidebarButtons();
  };


  const setSessionToggleState = (key, isOpen) => {
    try {
      sessionStorage.setItem(key, isOpen ? 'true' : 'false');
    } catch (e) {
      console.error('Failed to set sessionStorage for', key, e);
    }
  };

  const getSessionToggleState = (key) => {
    try {
      const value = sessionStorage.getItem(key);
      return value === null ? true : value === 'true'; // default to true (expanded)
    } catch (e) {
      console.error('Failed to read sessionStorage for', key, e);
      return true; // fallback to expanded on error
    }
  };



  const populateTemplates = () => {
    const templateTexts = [
      'Senior Scrum Master',
      'Senior Software Engineer',
      'Nurse Practitioner',
      'Entry Level Marketing Agent',
      'Director of Software Engineering',
      'Sr. Manager of Software Engineering',
      'Marketing Professional',
      'Experienced Sales Professional',
      'Motivated MBA Intern',
      'Cybersecurity Specialist',
      'Frontend Developer',
      'Backend Engineer',
      'Fullstack Developer',
      'Auto Mechanic',
      'Radiologist',
      'Marketing Manager',
      'School Teacher',
      'Pre-K School Teacher',
      'University Professor'
    ];

    const overwriteMap = {
      'プロジェクトマネージャー': 'Project Manager',
      '上級ソフトウェアエンジニア': 'Senior Software Engineer',
      'ナース・プラクティショナー': 'Nurse Practitioner',
      'マーケティングアシスタントマネージャー': 'Marketing Assistant Manager',
      'Engenheiro de Software Sênior': 'Senior Software Engineer',
      'スクラムマスター': 'Scrum Master',
      '高级软件工程师': 'Senior Software Engineer',
      '执业护士': 'Nurse Practitioner',
      '市场助理': 'Marketing Assistant',
      'Softwareentwickler - Mobiles Arbeiten': 'Senior Software Engineer',
      'Directeur de l’ingénierie logicielle': 'Director of Software Engineering',
      'Responsable de l’ingénierie logicielle': 'Sr. Manager of Software Engineering',
      'Ingénieur Logiciel Senior': 'Senior Software Engineer',
      'Director de Ingeniería de Software': 'Director of Software Engineering',
      'Gerente sénior de ingeniería de software': 'Sr. Manager of Software Engineering',
      'ソフトウェアエンジニアリングディレクター': 'Director of Software Engineering',
      'シニアマネージャー ソフトウェアエンジニアリング': 'Sr. Manager of Software Engineering',
      'Direttore dell\'Ingegneria del Software': 'Director of Software Engineering',
      'Responsabile senior dell\'ingegneria del software': 'Sr. Manager of Software Engineering',
      'Diretor de Engenharia de Software': 'Director of Software Engineering',
      'Gerente Sênior de Engenharia de Software': 'Sr. Manager of Software Engineering',
      '软件工程总监': 'Director of Software Engineering',
      '软件工程高级经理': 'Sr. Manager of Software Engineering',
      'Profesional de Ventas': 'Experienced Sales Professional',
      'Professionnel de la vente': 'Experienced Sales Professional',
      'Vertriebsprofi': 'Experienced Sales Professional',
      'セールスマネージャー': 'Experienced Sales Professional',
      'Professionista delle vendite': 'Experienced Sales Professional',
      'Profissional de Vendas': 'Experienced Sales Professional',
      '资深销售专家': 'Experienced Sales Professional',
      'Technologie-Praktikant': 'Technology Intern',
      'Direktor Softwareentwicklung': 'Director of Software Engineering',
      'Practicante de Tecnología': 'Technology Intern',
      'MBAインターン': 'MBA Intern',
      'テクノロジーインターン': 'Technology Intern',
      'マーケティングプロフェッショナル': 'Marketing Professional',
      'Stagista MBA': 'MBA Intern',
      'Stagista tecnologico': 'Technology Intern',
      'Estagiária de MBA': 'MBA Intern',
      'Estagiário de Tecnologia': 'Technology Intern',
      '市场营销专家': 'Marketing Professional',
      'MBA实习生': 'MBA Intern',
      '技术实习生': 'Technology Intern',
      'Leitender Frontend-Ingenieur': 'Frontend Developer',
      'Ingénieur Front-end': 'Frontend Developer',
      'Ingeniero frontend de personal': 'Frontend Developer',
      'スタッフフロントエンドエンジニア': 'Frontend Developer',
      'Ingegnere Frontend Senior': 'Frontend Developer',
      'Engenheiro Frontend Sênior': 'Frontend Developer',
      '高级前端工程师': 'Frontend Developer',
      'Backend-Entwickler': 'Backend Engineer',
      'Ingénieur Backend': 'Backend Engineer',
      'Ingeniero Backend': 'Backend Engineer',
      'バックエンドエンジニア': 'Backend Engineer',
      'Ingegnere Backend': 'Backend Engineer',
      'Engenheiro Backend': 'Backend Engineer',
      '后端工程师': 'Backend Engineer',
      'Full-Stack-Softwareentwickler/in': 'Fullstack Developer',
      'Ingénieur logiciel full stack': 'Fullstack Developer',
      'Profesional de software full stack': 'Fullstack Developer',
      'フルスタックソフトウェアエンジニア': 'Fullstack Developer',
      'Ingegnere Software Full Stack': 'Fullstack Developer',
      'Engenheiro(a) de Software Full Stack': 'Fullstack Developer',
      '全栈软件工程师': 'Fullstack Developer',
      'Erfahrener Kfz-Mechaniker': 'Auto Mechanic',
      'Mécanicien Automobile Expérimenté': 'Auto Mechanic',
      'Mecánico Automotriz': 'Auto Mechanic',
      '自動車整備士': 'Auto Mechanic',
      'Meccanico Automobilistico': 'Auto Mechanic',
      '汽车维修技师': 'Auto Mechanic',
      'Mecânico Automotivo': 'Auto Mechanic',
      'Fachärztin für Radiologie': 'Radiologist',
      'Radiologue': 'Radiologist',
      'Radióloga': 'Radiologist',
      '放射線科医': 'Radiologist',
      'Radiologa': 'Radiologist',
      '放射科医师': 'Radiologist',
      'Radiologista': 'Radiologist',
      'Marketingmanagerin': 'Marketing Manager',
      'Responsable marketing': 'Marketing Manager',
      'Gerenta de marketing': 'Marketing Manager',
      'ケティングマネージャー': 'Marketing Manager',
      'Responsabile marketing': 'Marketing Manager',
      'Gerente de marketing': 'Marketing Manager',
      '市场营销经理': 'Marketing Manager',
      'Grundschullehrerin': 'Elementary Teacher',
      'Professeure des écoles': 'Primary School Teacher',
      'Maestra de primaria': 'Primary School Teacher',
      '小学校教諭': 'Elementary Teacher',
      'Maestra di scuola primaria': 'Primary School Teacher',
      'Professora de Educação Infantil': 'Primary School Teacher',
      '小学教师': 'Primary School Teacher',
      'Kindergartenassistentin': 'Kindergarten Teaching Assistant',
      'Assistante d\'enseignement en maternelle': 'Kindergarten Teaching Assistant',
      '幼稚園補助教諭': 'Kindergarten Teaching Assistant',
      'Asistente de Docencia en Jardín de Infantes': 'Kindergarten Teaching Assistant',
      'Assistente all\'insegnamento': 'Kindergarten Teaching Assistant',
      'Assistente de professora de educação infantil': 'Kindergarten Teaching Assistant',
      '幼儿园助教': 'Kindergarten Teaching Assistant',
      'Juniorprofessorin': 'Junior Professor',
      'Maître de conférences': 'Lecturer',
      'Profesor asistente': 'Lecturer',
      '助教授': 'Assistant Professor',
      'Ricercatore universitario': 'Assistant Professor',
      'Professor assistente': 'Assistant Professor',
      '助理教授': 'Assistant Professor',


    };

    const container = document.querySelector('.collapsible-content-templates');
    const shadowHost = document.createElement('div'); // This will host the Shadow DOM
    shadowHost.id = 'defaulttemplates-leftsidebar-host';
    shadowHost.className = 'defaulttemplates-leftsidebar-shadow-host'; // Use a descriptive class name
    const shadowRoot = shadowHost.attachShadow({ mode: 'open' }); // Attach Shadow DOM to the host

    const style = document.createElement('style');

    style.textContent = textContent;

    shadowRoot.appendChild(style);
    if (!container) {
      return;
    }

    const language = getLanguage(); // Assume getLanguage is a function that retrieves the current language setting

    templateTexts.forEach((textTemp) => {
      const text = getI18n(textTemp);
      const textOverwrite = overwriteMap[text] || text;
      const formattedText = textOverwrite.toLowerCase().replace(/[.,]/g, '').replace(/\s+/g, '-'); // Convert to URL-friendly format
      const url = `/${language}/resume/templates/${language}/${formattedText}.html`;

      const link = document.createElement('a');
      link.href = url;
      link.target = '_self'; // Open the URL in a new tab
      link.rel = 'noopener noreferrer'; // For security and performance
      link.className =
        'flex h-10 items-center gap-2.5 rounded-lg px-2 text-token-text-primary text-ellipsis sidebar';
      link.innerHTML = `<span class="text-ellipsis text-sm">${text}</span>`;
      link.setAttribute('data-path', url);

      shadowRoot.appendChild(link);
    });

    container.appendChild(shadowHost);


    //The code populates the splides
    const iconIds = ['icon-growth', 'icon-folder-splide', 'icon-plus-box', 'icon-user-network'];
    const suffix = getI18n('Resume Template');
    const coverLetterSuffix =  getI18n('coverLetterTemplate');

    // First carousel: #image-carousel2 (normal order)
    const list1 = document.querySelector('#image-carousel2 .splide__list');
    if (list1) {
      templateTexts.forEach((textTemp, index) => {
        const text = getI18n(textTemp);
        const textOverwrite = overwriteMap[text] || text;
        const formattedText = textOverwrite.toLowerCase().replace(/[.,]/g, '').replace(/\s+/g, '-');
        const url = `/${language}/resume/templates/${language}/${formattedText}.html`;
        const iconId = iconIds[index % iconIds.length];

        const li = document.createElement('li');
        li.className = 'splide__slide';

        li.innerHTML = `
      <button class="relative flex w-40 flex-col gap-2 rounded-2xl border-token-border-light px-3 pb-4 pt-3 text-start align-top text-[15px] shadow-xxs transition enabled:hover:bg-token-main-surface-secondary disabled:cursor-not-allowed" onclick="navigate('${url}')">
        <svg width="24" height="24"><use xlink:href="#${iconId}"></use></svg>
        <div class="line-clamp-5 max-w-full text-balance text-gray-600 break-word">${text} ${suffix}</div>
      </button>
    `;

        list1.appendChild(li);
      });

      requestAnimationFrame(() => {
        const buttons = list1.querySelectorAll('.splide__slide > button');
        let maxHeight = 0;
        buttons.forEach(btn => {
          btn.style.height = 'auto';
          const h = btn.offsetHeight;
          if (h > maxHeight) maxHeight = h;
        });
        buttons.forEach(btn => {
          btn.style.height = `${maxHeight}px`;
        });
      });
    }

    // Second carousel: #image-carousel-custom-criteria (reverse order)
    const list2 = document.querySelector('#image-carousel-custom-criteria .splide__list');
    if (list2) {
      const reversedTexts = [...templateTexts].reverse();

      reversedTexts.forEach((textTemp, index) => {
        const text = getI18n(textTemp);
        const textOverwrite = overwriteMap[text] || text;
        const formattedText = textOverwrite.toLowerCase().replace(/[.,]/g, '').replace(/\s+/g, '-');
        const url = `/${language}/resume/templates/${language}/${formattedText}.html`;
        const iconId = iconIds[index % iconIds.length];

        const li = document.createElement('li');
        li.className = 'splide__slide';

        li.innerHTML = `
      <button class="relative flex w-40 flex-col gap-2 rounded-2xl border-token-border-light px-3 pb-4 pt-3 text-start align-top text-[15px] shadow-xxs transition enabled:hover:bg-token-main-surface-secondary disabled:cursor-not-allowed" onclick="navigate('${url}')">
        <svg width="24" height="24"><use xlink:href="#${iconId}"></use></svg>
        <div class="line-clamp-5 max-w-full text-balance text-gray-600 break-word">${text} ${suffix}</div>
      </button>
    `;

        list2.appendChild(li);
      });

      requestAnimationFrame(() => {
        const buttons = list2.querySelectorAll('.splide__slide > button');
        let maxHeight = 0;
        buttons.forEach(btn => {
          btn.style.height = 'auto';
          const h = btn.offsetHeight;
          if (h > maxHeight) maxHeight = h;
        });
        buttons.forEach(btn => {
          btn.style.height = `${maxHeight}px`;
        });
      });
    }


    const list3 = document.querySelector('#image-carousel-coverletter .splide__list');
    if (list3) {
      const coverLetterMap = constants.BASE_HORIZONTAL_SLIDERS_COVERLETTER_MAP[language] || constants.BASE_HORIZONTAL_SLIDERS_COVERLETTER_MAP['en-US'];
      const iconIdPool = iconIds; // reuse existing iconIds

      Object.entries(coverLetterMap).forEach(([filename, url], index) => {
        const text = filename;
        const iconId = iconIdPool[index % iconIdPool.length];
        const urlWithPrefix = `/${language}/coverletter${url}` ;

        const li = document.createElement('li');
        li.className = 'splide__slide';

        li.innerHTML = `
      <button class="relative flex w-40 flex-col gap-2 rounded-2xl border-token-border-light px-3 pb-4 pt-3 text-start align-top text-[15px] shadow-xxs transition enabled:hover:bg-token-main-surface-secondary disabled:cursor-not-allowed" onclick="navigate('${urlWithPrefix}')">
        <svg width="24" height="24"><use xlink:href="#${iconId}"></use></svg>
        <div class="line-clamp-5 max-w-full text-balance text-gray-600 break-word">${text} ${coverLetterSuffix}</div>
      </button>
    `;

        list3.appendChild(li);
      });

      requestAnimationFrame(() => {
        const buttons = list3.querySelectorAll('.splide__slide > button');
        let maxHeight = 0;
        buttons.forEach(btn => {
          btn.style.height = 'auto';
          const h = btn.offsetHeight;
          if (h > maxHeight) maxHeight = h;
        });
        buttons.forEach(btn => {
          btn.style.height = `${maxHeight}px`;
        });
      });
    }





  };

  const populateLeftSidebarContent = () => {
    const data = createUpdateFilesEvents.getData(); // Retrieve data
    if (!data || !Array.isArray(data) || data.length === 0) {
      $('#quickResumeSection').hide(); // Hide the whole My Resume section
      $('#quickResumeSectionSpacer').hide(); // Hide the whole My Resume section
      return; // Exit the function early
    } else {
      $('#quickResumeSection').show(); // Hide the whole My Resume section
      $('#quickResumeSectionSpacer').show(); // Hide the whole My Resume section
    }

    const container = document.querySelector('.collapsible-content'); // Match the existing static container
    const shadowHost = document.createElement('div'); // This will host the Shadow DOM
    shadowHost.className = 'resume-leftsidebar-shadow-host'; // Use a descriptive class name
    shadowHost.id = 'resume-leftsidebar-host';
    const shadowRoot = shadowHost.attachShadow({ mode: 'open' }); // Attach Shadow DOM to the host

    const style = document.createElement('style');

    style.textContent = textContent;

    shadowRoot.appendChild(style);
    if (!container) {
      return;
    }

    data.forEach((file) => {
      if (!file || !file.shortDescription || !file.filePath || !file.fileName) {
        console.warn("Invalid file data encountered:", file);
        return;
      }

      const contentContainer = document.createElement('div');
      contentContainer.className = 'leftsidebar-content-container';

      // Button container
      const buttonContainer = document.createElement('div');
      buttonContainer.className = 'leftsidebar-button-container';

      // Main button
      const mainButton = document.createElement('button');
      mainButton.className =
        'leftsidebar-main-button flex h-10 w-full items-center gap-2.5 rounded-lg px-2 text-token-text-primary text-ellipsis sidebar';
      mainButton.innerHTML = `<span class="text-ellipsis text-sm">${new Date(file.lastUpdated).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })}: ${file.type} - ${file.shortDescription}</span>`;
      mainButton.setAttribute('data-path', file.filePath);

      // Click event to open the file
      const openFile = () => {
        if (file.filePath) {
          console.log('file.filePath', file.filePath);
          navigate(file.filePath);
        } else {
          console.error("File path is missing for:", file);
        }
      };


      addListener(mainButton, 'click', openFile);
      if (pointyDevices) {
        // Ellipsis button
        const ellipsisButton = document.createElement('button');
        ellipsisButton.className = 'leftsidebar-ellipsis-button hidden';
        ellipsisButton.textContent = '...';

        // Dropdown
        const dropdown = document.createElement('div');
        dropdown.id = 'leftsidebar-dropdown';
        dropdown.className = 'leftsidebar-dropdown text-sm hidden';


        // Dropdown actions
        addListener(dropdown, 'click', (event) => {
          const action = event.target.closest('.myresumes-option')?.dataset.action;
          if (!action) return;

          if (action === 'open') {
            openFile();
          } else if (action === 'delete') {
            const fileToDelete = {
              filename: file.fileName,
              path: file.filePath,
              metadatafilelink: file.metadatafilelink
            };
            handleDelete(fileToDelete, contentContainer);
          } else if (action === 'rename') {
            const prefix = `${new Date(file.lastUpdated).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })}: ${file.type} - `;
            handleRename(mainButton, buttonContainer, ellipsisButton, file.fileName, openFile, file.shortDescription, prefix);
          } else if (action === 'share') {
            alert('Share functionality coming soon!');
          }
        });
        buttonContainer.appendChild(mainButton);
        buttonContainer.appendChild(ellipsisButton);
        buttonContainer.appendChild(dropdown);
        contentContainer.appendChild(buttonContainer);
        // Hover behavior for ellipsis button
        addListener(buttonContainer, 'mouseenter', () => {
          if (!buttonContainer.classList.contains('renaming')) {
            ellipsisButton.classList.remove('hidden');
          }
        });
        addListener(buttonContainer, 'mouseleave', () => {
          if (!buttonContainer.classList.contains('renaming')) {
            ellipsisButton.classList.add('hidden');
          }
        });
      }
      else {
        buttonContainer.appendChild(mainButton);
        contentContainer.appendChild(buttonContainer);
      }


      shadowRoot.appendChild(contentContainer);
      container.appendChild(shadowHost);
    });
  };

  const addListener = (element, event, handler) => {
    if (element) {
      element.addEventListener(event, handler);
      listeners.push({ element, event, handler }); // Track listener for removal
    }
  };

  const handleRename = async (mainButton, buttonContainer, ellipsisButton, originalFileName, openFile, shortDescription, prefix) => {
    const event = new CustomEvent("defaultFunctionsAccessSuccess", {
      detail: {
        message: 'verificationCompleted',
        callback: () => thisEditor.handleRename(mainButton, buttonContainer, ellipsisButton, originalFileName, openFile, shortDescription, prefix), // Pass function reference
      },
    });
    console.log("Dispatching event", "defaultFunctionsAccessSuccess");
    window.dispatchEvent(event);
  };

  const toggleCollapsible = () => {
    content.classList.toggle('open'); // Toggle content visibility
    iconCollapse.classList.toggle('hidden');
    iconExpand.classList.toggle('hidden');
  };

  const unload = () => {
    // Function to remove styles and then remove the element
    const removeChildAndStyles = (element) => {
      if (element instanceof HTMLElement) {
        element.removeAttribute("style"); // Remove inline styles
        element.removeAttribute("class"); // Remove class attributes
      }
      element.remove(); // Remove the child element
    };

    // Remove toggle button listener
    listeners.forEach(({ element, event, handler }) => {
      element.removeEventListener(event, handler);
    });
    listeners.length = 0; // Clear the array

    // Remove dropdown click listeners

    // if ($('.leftsidebar-dropdown')) $('.leftsidebar-dropdown').off();
    // if ($('.leftsidebar-ellipsis-button')) $('.leftsidebar-ellipsis-button').off();
    $(document).off('.leftsidebar');

    // Clear dynamically created children while preserving containers
    const containers = document.querySelectorAll('.collapsible-content');
    if (containers) {
      containers.forEach((container) => {
        while (container.firstChild) {
          if (container.firstChild) removeChildAndStyles(container.firstChild);
        }
      });
    }
  };


  const unloadAll = () => {
    // Remove toggle button listener
    listeners.forEach(({ element, event, handler }) => {
      element.removeEventListener(event, handler);
    });
    listeners.length = 0; // Clear the array


    // Remove dropdown click listeners
    if ($('.leftsidebar-dropdown')) $('.leftsidebar-dropdown').off();
    if ($('.leftsidebar-ellipsis-button')) $('.leftsidebar-ellipsis-button').off();
    $(document).off('.leftsidebar');

    // Clear dynamically created elements
    // Clear dynamically created elements
    const containers = document.querySelectorAll('.collapsible-content, .collapsible-content-templates');
    if (containers) containers.forEach((container) => (container.innerHTML = ''));
  };


  // Function to deflate and encode the content
  const deflateAndEncode = (content) => {
    // Use pako to deflate the string content
    const deflatedContent = pako.deflate(content, { to: 'string' });

    // Encode the deflated content with btoa
    return btoa(deflatedContent);
  };


  const handleDelete = (fileToDelete, contentContainer) => {
    const event = new CustomEvent("defaultFunctionsAccessSuccess", {
      detail: {
        message: 'verificationCompleted',
        fileToDelete: fileToDelete, // Pass fileToDelete
        callback: () => thisEditor.doDeleteFile(fileToDelete, contentContainer), // Pass function reference
      },
    });
    console.log("Dispatching event", "defaultFunctionsAccessSuccess");
    window.dispatchEvent(event);
  };

  const textContent = `

    /** Start of left side bar style **/
.hidden, .hidden1 {
    display: none;
}
.hidden {
    display: none !important;
}
.text-ellipsis {
    text-overflow: ellipsis;
}
.px-2 {
    padding-left: .5rem;
    padding-right: .5rem;
}
.rounded-lg {
    border-radius: .5rem;
}
.text-token-text-primary {
    color: var(--text-primary);
}
.gap-2\.5 {
    gap: .625rem;
}
.items-center {
    align-items: center;
}
.w-full {
    width: 100%;
}
.h-10 {
    height: 2.5rem;
}
.flex {
    display: flex;
}
.text-sm {
    font-size: .89rem;
    line-height: 1.25rem;
}
.text-ellipsis {
    overflow: hidden;
    white-space: nowrap;
}
.pl-2, .px-2 {
    padding-left: .5rem !important;
}
.pr-2, .px-2 {
    padding-right: .5rem !important;
}
.rounded-lg {
    border-radius: .3rem !important;
}


/* Wrapper for the buttons */
.leftsidebar-content-container {
  padding: 0;
  position: relative;
}

/* Button container for relative positioning */
.leftsidebar-button-container {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 0px;
  gap: 8px; /* Add spacing between the main button and the ellipsis button */
}

/* Main button styling */
.leftsidebar-main-button {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0px;
  text-align: left;
  font-size: 14px;
}

/* Ellipsis button */
.leftsidebar-ellipsis-button {
  background: var(--sidebar-hover);
  border: 1px solid var(--border-medium); /* Add border around the ellipsis button */
  border-radius: 4px; /* Optional: Rounded corners */
  cursor: pointer;
  padding: 6px 8px; /* Add padding inside the ellipsis button */
  font-size: 16px;
  color: gray;
  transition: all 0.2s ease; /* Optional: Smooth hover effect */
}

/* Ellipsis button hover effect */
.leftsidebar-ellipsis-button:hover {
  background: var(--color-left-side-bar); /* Change background on hover */
  border-color: var(--border-xheavy); /* Change border color on hover */
}

/* Show ellipsis button on hover */
.leftsidebar-button-container:hover .leftsidebar-ellipsis-button {
  display: inline-block;
}

/* Dropdown styling */
.leftsidebar-dropdown {
  position: absolute;
  right: 5px;
  top: 100%;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 10px;
  z-index: 10;
}

/* Collapsible container */
.collapsible-container {
}

/* Header styling */
.collapsible-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0px;
  margin-bottom: 0.5rem;
}

/* Toggle button styling */
.collapsible-toggle {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

/* SVG styling */
.collapsible-toggle svg {
  width: 16px;
  height: 16px;
  color: #333;
}

/* Collapsible content */
.collapsible-content {
  padding: 0px;
  display: block; /* Visible by default */
}

.collapsible-content.open {
  display: block; /* Visible when expanded */
}

.collapsible-content:not(.open) {
  display: none; /* Hidden when collapsed */
}

/* Collapsible content */
.collapsible-content-templates {
  padding: 0px;
  display: block; /* Visible by default */
}

.collapsible-content-templates.open {
  display: block; /* Visible when expanded */
}

.collapsible-content-templates:not(.open) {
  display: none; /* Hidden when collapsed */
}

.leftsidebar-dropdown {
  position: absolute;
  right: 0;
  top: 100%;
  background-color: var(--slider-top);
  border: 1px solid var(--resume-border);
  border-radius: 20px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1105;
  padding: 10px 20px;
  transition: background-color 0.3s ease;
  margin-top: 3px;
}

.leftsidebar-dropdown ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.leftsidebar-dropdown li {
  padding: 5px 0;
}

.leftsidebar-dropdown li a {
  text-decoration: none;
  color: #333;
}

.leftsidebar-dropdown li a:hover {
  text-decoration: underline;
}

/* Ensure hover styles are disabled during renaming */
.leftsidebar-button-container.renaming:hover {
  background-color: transparent; /* Remove hover background */
  cursor: default; /* Change cursor to default */
}

/* Hide the ellipsis button explicitly during renaming */
.leftsidebar-button-container.renaming .leftsidebar-ellipsis-button {
  display: none !important;
}

/* Adjust the main button to occupy full width during renaming */
.leftsidebar-button-container.renaming .leftsidebar-main-button {
  width: 100%; /* Ensure the input field or text takes full width */
}

/* Optional: Add a border to the renaming input for better visibility */
.leftsidebar-button-container.renaming .rename-input {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 4px;
  outline: none; /* Remove default outline */
  background-color: var(--color-secondary-background) !important;
  border: 1px solid var(--secondary-background-border-color) !important;
  color: var(--text-primary) !important;
  -webkit-text-fill-color: var(--text-primary) !important;
  caret-color: var(--text-primary) !important;
  transition: background-color 5000s ease-in-out 0s;
}

.custom-option1,
.custom-option2,
.custom-option3,
.myresumes-option {
  display: flex;
  align-items: center;
  gap: 10px; /* Space between icon and text */
  padding: 10px;
  cursor: pointer;
  padding-left: 10px;
  transition: background-color 0.3s ease;
}

.custom-option1 svg,
.custom-option2 svg,
.custom-option3 svg,
.myresumes-option svg {
  flex-shrink: 0; /* Ensure the icon doesn't shrink */
}

.custom-dropdown-container {
  position: relative;
  width: 100%;
  margin: 0;
}

.custom-dropdown-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  border: 0;
  border-radius: 4px;
  background-color: transparent;
  cursor: pointer;
  transition: none;

  width: 100%;
}

/* Background color for hovered option */
.custom-option1:hover,
.custom-option2:hover,
.custom-option3:hover,
.myresumes-option:hover {
  background-color: var(--sidebar-hover);
}

.sidebar{
    text-decoration: none;

}

.leftnav-buttonactive {
  background-color: var(--sidebar-hover);
}




@media (hover: hover) and (pointer: fine) {
  .sidebar:hover{
   background-color: var(--sidebar-hover);
  }
}


/** End of left side bar style **/

    `;

  return {
    init,
    unload,
    unloadAll,
  };
})();

export default leftsidebarpopulate;
